import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './layout.css';
import { motion } from 'framer-motion';


const Layout = ({ children }) => {
  return (
    <div className="app-container">
      <Navbar />

    
      <div className="layout-wrapper">
        <motion.div
          className="page-background"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.6 }}
        >
          {children}
        </motion.div>

        <Footer />
      </div>
    </div>
  );
};

export default Layout;
